import React from 'react';

import {
  useRecordContext,
} from 'react-admin';

import { Chip } from '@mui/material';
import { get } from 'lodash';

const ChipStringField = ({
  source,
  hasLink = false,
}: {
  source?: string;
  hasLink?: boolean;
}) => {
  const record = useRecordContext();
  const value = source ? get(record, source, {}) : record;
  return (
    <Chip
      label={value}
      sx={hasLink ? { '& .MuiChip-label': { textDecoration: 'underline' } } : {}}
      clickable={hasLink}
    />
  );
};

export default ChipStringField;
